
export class TreeNodeData {
  data: any;
  type: string;
  constructor(data: any, type: string) {
    this.data = data;
    this.type = type;
  }
}
